import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TrustPipe } from '@frontend/sports/common/core/utils/dom';
import { EffectsModule } from '@ngrx/effects';
import { EpcotNotificationComponent } from 'packages/sports/web/app/src/common/epcotNotifications/notification.component';

import { BetBuilderNotificationComponent } from './components/betbuilder-notification.component';
import { BetslipNotificationEffects } from './effects';
import { BetslipNotificationUtils } from './services/betslip-notification.utils';

@NgModule({
    declarations: [BetBuilderNotificationComponent],
    imports: [CommonModule, EffectsModule.forFeature([BetslipNotificationEffects]), EpcotNotificationComponent, TrustPipe],
    providers: [BetslipNotificationUtils],
    exports: [BetBuilderNotificationComponent],
})
export class NotificationsModule {}
